

import { Component, Vue, Watch, Prop } from 'vue-property-decorator';

@Component({
  components: {
  },
})
export default class ProductTreeLevel extends Vue {
  @Prop({ default: () => [] })
  public items: any[];

  @Prop({ default: () => ({}) })
  public internalSelectionState: any;

  @Prop({ default: 1 })
  public level: number;

  @Prop({ default: '' })
  public filter: string;

  public expandedMap: any = {};

  get definedItems() {
    return this.items.filter((item: any) => !!item);
  }

  public getPseudoSelectorStyling() {
    return {
      'padding-left': 10 + (this.level * 30) + 'px'
    }
  }

  public getPseudoCheckboxStyling() {
    return {
      'left': 10 + ((this.level - 1) * 30) + 'px'
    }
  }

  public selectInChild(product: any) {
    this.$emit('select', product);
  }

  @Watch('filter')
  public onPropertyChanged(value: string, oldValue: string) {
    this.createMap();
  }

  public createMap() {
    const obj: any = {};
    this.definedItems.forEach((item) => {
      if (this.filter && this.filter.length) {
        const filter = this.filter.toLowerCase();
        if (item.display && item.display.toLowerCase().indexOf(filter) === -1) {
          // We have a filter, this item is showing, but it does not itself match the filter.
          // We can therefore conclude one of its descendents does, so expand
          obj[item.id] = true;
          return;
        }
      }

      obj[item.id] = false;
    });
    this.expandedMap = {...obj};
  }

  public mounted() {
    // TODO: do this when items array changes too.. maybe?
    this.createMap();
  }
}

